export default "__VITE_ASSET__CAzCe3pN__"